import React from 'react';
import TemperatureChip from '../../TemperatureChip';
import {
  getTemperatureColorFromInsight,
  getTemperatureFromInsight,
} from '../../TemperatureChip/temperature';

/** Temperature of the contact's latest AI insight (1–5); nothing without one. */
export default function ContactTemperatureChip({ value }) {
  if (!value) return null;
  return (
    <TemperatureChip
      hasInsight
      temperatureValue={value}
      temperature={getTemperatureFromInsight(value)}
      temperatureColor={getTemperatureColorFromInsight(value)}
    />
  );
}
